
export const GET_HISTORY_DATA_SUCCESS = 'GET_HISTORY_DATA_SUCCESS';
export const getHistoryDataSuccess = (data, dataType) => ({
  type: GET_HISTORY_DATA_SUCCESS,
  payload: {
    data,
    dataType,
  },
});

export const GET_HISTORY_DATA_ERROR = 'GET_HISTORY_DATA_ERROR';
export const getHistoryDataError = error => ({
  type: GET_HISTORY_DATA_ERROR,
  payload: {
    error,
  },
});
export const TOGGLE_ROOM_DETAIL_LOADING = 'TOGGLE_ROOM_DETAIL_LOADING';
export const toggleRoomDetailLoading = isLoading => ({
  type: TOGGLE_ROOM_DETAIL_LOADING,
  payload: { isLoading },
});
